import React from 'react';
import PropTypes from 'prop-types';

import { Field, reduxForm, SubmissionError } from 'redux-form';

import { withStyles } from '@material-ui/core/styles';

import UploadField from 'components/fields/UploadField';

import { createPatientDocument } from 'redux/modules/patientsDocuments';

const styles = theme => ({
  root: {
    padding: '27px 24px',
    borderBottom: `1px solid ${theme.palette.primary.A400}`,
  },
});

function onSubmit(values, dispatch, props) {
  return new Promise((resolve, reject) => {
    dispatch(createPatientDocument({
      values: {
        'Record Number': props.patient['Record Number'],
        ...values,
      },
      resolve,
      reject,
    }));
  })
    .then((res) => {
      dispatch(props.reset());
      return res;
    },
    (err) => {
      if (err.error) {
        throw new SubmissionError({ _error: err.error });
      }
      throw new SubmissionError(err);
    });
}

function onChange(values, dispatch, props) {
  if (values.Document.name) {
    props.submit();
  }
}

const PatientsDialogDocumentsUploadForm = ({
  handleSubmit,
  submitting,
  classes,
}) => (
  <div className={classes.root}>
    <form
      noValidate
      autoComplete="off"
      onSubmit={handleSubmit}
    >
      <Field
        id="Document"
        name="Document"
        component={UploadField}
        variant="document"
        label="Drag file here or attach it"
        loading={submitting}
        fullWidth
      />
    </form>
  </div>
);

PatientsDialogDocumentsUploadForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
  }).isRequired,
};

export default reduxForm({
  onSubmit,
  onChange,
  form: 'patientDocumentsExpress',
  initialValues: {
    Document: {
      name: null,
    },
  },
})(withStyles(styles)(PatientsDialogDocumentsUploadForm));



// WEBPACK FOOTER //
// ./src/components/patient/PatientsDialog/PatientsDialogDocumentsUploadForm.js